import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { TicketingService } from '../../services/ticketing-service/ticketing.service';

import { TListService } from '../services/ticketing.service';

@Component({
  selector: 'mcrit-gestio-ticketing-filtres',
  templateUrl: 'ticketing-filtre.component.html',
  styleUrls: ['ticketing-filtre.component.css'],
  providers: []
})
export class TicketingFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;
  public state: any = 'in' ;

  constructor(public translate: TranslateService, public languageService: LanguageService, private listService: TListService, private spService: TicketingService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }


  public resetActiveFilters() {
    const newFilter = {};
    for (let key of this.filterModel)newFilter[key] = null;
    this.listService.valFiltres={};
    this.filterModel = newFilter;
    this.sendActiveFilters();
  }

  ngOnInit() {
    let requestedAutocompletes = [];
    this.filterModel = this.validFilters.reduce((acum, curr) => {
      curr.inputs.forEach(inputGroup => {
        switch (inputGroup.type) {
          case 'select':
            acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
            break;
          default:
            inputGroup.values.forEach(input => {
              if(input.autocomplete)requestedAutocompletes.push(input.autocomplete);
                acum[input.name] = (input.value ? input.value : null);
              });
            }
      });
      return acum;
    }, {});

    this.dataLists = requestedAutocompletes.map(id => {
      return {
        id: id,
        options: this.spService.getAutocomplete(id)
      };
    });
    this.sendActiveFilters();
  }

  isTextOnly(id: string): boolean {
    return id === 'tipusTicket' || id === 'subTipusTicket';
  }

}
